import { Injectable } from "@angular/core";
import { NotificationModel, NotificationType } from "app/core/models";

@Injectable()
export class NotificationService {
    //#region Fields

    private _notifications: NotificationModel[] = [];

    //#endregion

    //#region Properties

    get notifications(): NotificationModel[] {
        return this._notifications;
    }

    //#endregion

    //#region Utilities

    private addNotification(body: string, title: string, type: NotificationType, timeout: number = 5000) {
        let model = new NotificationModel();
        model.body = body;
        model.title = title;
        model.type = type;
        model.delay = timeout;
        this._notifications.push(model);
    }

    //#endregion

    //#region  Methods

    showSuccess(body: string, title: string) {
        if (!(body || title))
            return;

        this.addNotification(body, title, NotificationType.Success);
    }

    showError(body: string, title: string) {
        if (!(body || title))
            return;

        this.addNotification(body, title, NotificationType.Danger,10000);
    }

    showWarning(body: string, title: string) {
        if (!(body || title))
            return;

        this.addNotification(body, title, NotificationType.Warning);
    }

    remove(notification: NotificationModel) {
        this._notifications = this.notifications.filter((n) => n !== notification);
    }

    clear() {
        this.notifications.splice(0, this.notifications.length);
    }

    //#endregion
}
